@if (answersState?.flashcard?.image) {
    <img class="activity-edition-preview-recording__image"
         [src]="answersState.flashcard.image.uri"
         [alt]="answersState.flashcard.image.alt"
         [@fadeAndSlideInAndOut]>
} @else {
    <div class="activity-edition-preview-recording__image-placeholder"
        [@fadeAndSlideInAndOut]>
        <mat-icon class="activity-edition-preview-recording__image-placeholder-icon"
                  svgIcon="activity-edition-preview-recording__image">
        </mat-icon>
        <p class="activity-edition-preview-recording__image-placeholder-text"
           [innerHTML]="'activity_edition.add_image
' | translate">
        </p>
    </div>
}

<div class="activity-edition-preview-recording__pseudo-actions">
    <div class="activity-edition-preview-recording__listen-pseudo-button">
        <span>{{ 'activities.listen_incoming_audio' | translate }}</span>
        <mat-icon svgIcon="voice-recorder__listen"></mat-icon>
    </div>
    <div class="activity-edition-preview-recording__record-pseudo-button">
        <span>{{ 'activities.record_audio' | translate }}</span>
        <mat-icon svgIcon="voice-recorder__record"></mat-icon>
    </div>
    <div class="activity-edition-preview-recording__compare-pseudo-button">
        <span>{{ 'activities.listen_and_compare' | translate }}</span>
        <mat-icon svgIcon="voice-recorder__listen-and-compare"></mat-icon>
    </div>
</div>
